import axios from '../axios';
import config from '../config';

export default {
    getOneUser(username, token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${username}`,
            headers: { token }
        })
    },
    getMarketersList(token, tokenBusiness) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/marketers/report`,
            headers: { Authorization: `Bearer ${token}`, token: tokenBusiness }
        })
    },
    updateMarketerInfo(marketerInfo, token, tokenBusiness) {
        return axios({
            method: 'put',
            baseURL: config.apiUrls(),
            url: `/v1/business/marketers`,
            data: JSON.stringify(marketerInfo),
            headers: { Authorization: `Bearer ${token}`, token: tokenBusiness, "content-type": "application/json" }
        })
    },
    getUserBusinesses(BusinessToken) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: '/v1/user/business',
            headers: { token: BusinessToken }
        });
    },
    getUsersPerPage(token, params) {
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: '/v1/business/user-paged-result',
            headers: { token },
            data: params

        });
    },
    getAllUsers(token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: '/v1/business/user',
            headers: { token }
        });
    },
    getFilterUsers(token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: '/v1/business/users',
            headers: { token }
        })
    },
    getPromoters(token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: '/v1/business/promoter',
            headers: { token }
        })
    },
    postUser(params, token) {
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: '/v1/business/user',
            data: params,
            headers: { token }
        })
    },
    updateUser(params, Username, token) {
        return axios({
            method: 'put',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${Username}`,
            data: params,
            headers: { token }
        })
    },
    deleteUser(Username, token) {
        return axios({
            method: 'delete',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${Username}`,
            headers: { token }
        })
    },

    getUserSale(Username, token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${Username}/sale`,
            headers: { token }
        })
    }, postRecalculateMarketerComission(insuranceRequestId, token) {
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: `/v1/business/insurance/recalculate-marketer-commission/${insuranceRequestId}`,
            headers: { token }
        })
    },
    getUserAgentWage(userId, token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/agent-wage/${userId}`,
            headers: { token }
        })
    },
    putUserAgentWage(data, token) {
        return axios({
            method: 'put',
            baseURL: config.apiUrls(),
            url: '/v1/business/agent-wage',
            data,
            headers: { token }
        })
    },
    postUserAgentWage(data, token) {
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: '/v1/business/agent-wage',
            data,
            headers: { token }
        })
    },
    deleteUserAgentWage(UserId, BranchId, token) {
        return axios({
            method: 'delete',
            baseURL: config.apiUrls(),
            url: `/v1/business/agent-wage/user/${UserId}/branch/${BranchId}`,
            headers: { token }
        })
    },
    getUserMobileHistory(Username, token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${Username}/mobile-number-history`,
            headers: { token, BusinessToken: token }
        })
    },
    changeUserMobileNumber(Username, data, token) {
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: `/v1/business/user/${Username}/mobile-number`,
            data,
            headers: { token, BusinessToken: token }
        })
    },

}